import { last } from "@/utils/helper";
import Container from "../common/Container";

const OurExpertise = (properties) => {
  const { headLine, expertiseTools } = properties.expertiseSection;

  return (
    <Container large className="bg-primary-black pt-20 md:pt-24">
      <h2 className="mb-10 md:mb-20 text-white text-4xl md:text-3xl lg:text-6xl font-medium lg:leading-tight">
        <span>{headLine}</span>
      </h2>
      {expertiseTools && expertiseTools.length > 0
        ? expertiseTools.map((value, index) => (
            <div key={index}>
              <div className="flex flex-col md:flex-row">
                <div className="w-full md:w-4/12 col-md-4">
                  <p className="text-base md:text-xl text-primary-yellow mb-4 md:mb-0">
                    <span>{value.techExpertiseKey}</span>
                  </p>
                </div>
                <div className="flex flex-wrap w-full md:w-8/12">
                  {value.techExpertiseValues.map((item) => (
                    <div key={item.name}>
                      <p className="mt-0 mr-4 mb-4 py-2 md:mb-2 px-4 border border-solid border-gray-600 rounded-3xl text-sm lg:text-base text-white font-light">
                        <span>{item.name}</span>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              {index === last(expertiseTools) ? undefined : (
                <hr className="my-6 md:my-8 w-full h-px bg-gray-300/25 border-t-0" />
              )}
            </div>
          ))
        : undefined}
    </Container>
  );
};

export default OurExpertise;
